import { Question } from "../../models/question";

interface IQuestionsProps {
  questions: Question[] | null | undefined;
  parcours: string;
}

function QuestionsSommaireErreurs(props: Readonly<IQuestionsProps>) {

  const questionsSansReponse = props.questions?.filter((q) => q.reponse == null);

  function construireError(questionsSansReponse: Question[]) {
    return JSON.stringify(
      questionsSansReponse.map((question: Question) => ({
        id: question.id,
        text: question.libelles?.libelleErreur
      }))
    );
  }

  if (questionsSansReponse?.length) {
    return (
      <dsd-form-error-summary
        errors={construireError(questionsSansReponse)}
        errors-on-load="false"
        titleLevel="3"
        data-testid="libelle-erreur-sommaire-amc"
      >
      </dsd-form-error-summary>
    );
  }

  return null;
}

export default QuestionsSommaireErreurs;